export const LOAD_PACK_LIST = "LOAD_PACK_LIST";

export const LoadPackList = (payload) => {
    return {
      type: LOAD_PACK_LIST,
      payload,
    };
  };